import type { VX_TESTS_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/vx-tests-table/vx-tests-table.fr.ts";

import { EInstallTestState } from "~domain/install-tests/models/install-test-state-model.ts";

const testInstallStatus: Record<EInstallTestState, string> = {
  [EInstallTestState.OK]: "Ok",
  [EInstallTestState.NOK]: "Nok",
  [EInstallTestState.UNKNOWN]: "Unknown",
};

export const VX_TESTS_TABLE_ENGLISH_LOCALE = {
  searchPlaceholder: "Search a value...",
  noTestFound: "No test found...",
  headers: {
    testId: "Test Id",
    state: "Result",
    resultDetails: "Result details",
    measuredPower: "Measured power",
    serialNumber: "Serial number",
    deviceType: "Device type",
    pilotHwId: "Pilot Hw ID",
    isAutoTestAllowed: "Is autotest allowed ?",
    startDate: "Start date",
    endDate: "End date",
    receptionDate: "Reception date",
  },
  filters: {
    placeholders: {
      testId: "Search by test id...",
      state: "Search by result...",
      serialNumber: "Search by serial number...",
      deviceType: "Search by device type...",
      pilotHwId: "Search by pilot hw id...",
      startDate: "Search by start date...",
      endDate: "Search by end date...",
      receptionDate: "Search by reception date...",
    },
  },
  testInstallStatus: testInstallStatus,
} satisfies typeof VX_TESTS_TABLE_FRENCH_LOCALE;
